/* Bedtextielonline (Claude): euroteken bij prijzen die door onze eigen scripts worden ingevuld
   (bv. 'Maak je bed compleet' na een maat- of kleurwissel). Doet alleen iets als het geldformaat van de winkel een € bevat,
   zodat alle prijzen er dan hetzelfde uitzien als de prijzen uit Shopify zelf. */
(function () {
  var s = window.themeVariables && window.themeVariables.settings;
  var f = (s && s.moneyFormat) || '';
  if (f.indexOf('€') < 0 && f.indexOf('&euro;') < 0) return;
  var voor = f.split('{{')[0].replace('&euro;', '€');
  var PRIJS = /^\s*\d{1,3}(\.\d{3})*,\d\d\s*$/;
  var bezig = false;
  function zet(root) {
    if (bezig) return;
    bezig = true;
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (!PRIJS.test(n.nodeValue)) continue;
      var p = n.parentNode;
      if (!p || /^(SCRIPT|STYLE|OPTION|TEXTAREA)$/.test(p.nodeName)) continue;
      if (p.closest && p.closest('[data-btol-geen-euro]')) continue;
      n.nodeValue = voor + n.nodeValue.trim();
    }
    bezig = false;
  }
  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(function () { zet(); }, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { zet(); }); else zet();
  if (window.MutationObserver) new MutationObserver(function () { if (!bezig) straks(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Bedtextielonline (Claude): maak je de winkelwagen leeg terwijl je naar beneden gescrold was,
   dan springt de lade terug naar boven, zodat je 'Je winkelwagen is nog leeg' meteen ziet. */
(function () {
  var vorige = null;
  function kijk() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.shadowRoot) return;
    var leeg = !!d.querySelector('.btol-leeg');
    if (leeg && vorige === false) {
      var b = d.shadowRoot.querySelector('[part~="body"]');
      if (b) b.scrollTop = 0;
    }
    vorige = leeg;
  }
  function start() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    kijk();
    new MutationObserver(kijk).observe(d, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Bedtextielonline (Claude): vaste knop onderaan de productpagina (gsm en tablet) compact, zoals bij Smulders:
   één rij met een keuzelijst voor de maat en de knop 'In winkelwagen'. De keuzelijst stuurt de gewone maatkeuze op de pagina aan. */
(function () {
  var btolT = function (k, d, v, ruw) { var s = (window.BTOL_T && window.BTOL_T[k]) || d; if (!ruw && !/_html$/.test(k)) s = String(s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[e]; }); if (v) Object.keys(v).forEach(function (n) { s = String(s).split('{' + n + '}').join(v[n]); }); return s; };
  var st = document.createElement('style');
  st.textContent =
    '@media (max-width:999px){' +
      'product-sticky-bar.btol-sticky--keuze{display:flex!important;align-items:center;gap:8px}' +
      'product-sticky-bar.btol-sticky--keuze .product-sticky-bar__info,product-sticky-bar.btol-sticky--keuze .btol-sticky-maat{display:none!important}' +
      'product-sticky-bar.btol-sticky--keuze buy-buttons{flex:1 1 55%;min-width:0}' +
      /* :not(#btol) wint van de algemene knopregel (padding 28px, hoogte 52px) */
      'product-sticky-bar.btol-sticky--keuze buy-buttons .button:not(#btol){width:100%;min-height:48px!important;padding-inline:14px!important;font-size:16px!important}' +
      '.btol-sticky-keuze{flex:1 1 auto;min-width:0;height:48px;padding:0 32px 0 14px;border:1.5px solid rgba(47,42,68,.22);border-radius:999px;' +
        'background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%232F2A44\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'M6 9l6 6 6-6\'/%3E%3C/svg%3E") right 12px center/16px 16px no-repeat;' +
        'color:#2F2A44;font:inherit;font-size:14.5px;font-weight:600;-webkit-appearance:none;appearance:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}' +
      '.btol-sticky-keuze:focus-visible{outline:3px solid rgba(47,42,68,.28);outline-offset:2px}' +
    '}' +
    /* smalle gsm: winkelwagen-icoon + prijs in de knop (de tekst past er niet meer naast de maat) */
    '@media (max-width:420px){product-sticky-bar.btol-sticky--keuze buy-buttons:not(#btol){flex:0 0 auto;width:auto;min-width:0;display:block}product-sticky-bar.btol-sticky--keuze buy-buttons .button:not(#btol){width:auto;padding-inline:18px!important;white-space:nowrap}product-sticky-bar.btol-sticky--keuze buy-buttons .btol-k-kort,product-sticky-bar.btol-sticky--keuze buy-buttons .btol-k-lang,product-sticky-bar.btol-sticky--keuze buy-buttons .btol-k-streep{display:none!important}' +
      'product-sticky-bar.btol-sticky--keuze buy-buttons .btol-k-prijs{display:inline-flex!important;align-items:center;gap:8px}' +
      'product-sticky-bar.btol-sticky--keuze buy-buttons .btol-k-prijs::before{content:"";width:20px;height:20px;flex:0 0 20px;background:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23fff\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6\'/%3E%3Ccircle cx=\'10\' cy=\'20\' r=\'1.4\'/%3E%3Ccircle cx=\'17\' cy=\'20\' r=\'1.4\'/%3E%3C/svg%3E") center/20px 20px no-repeat}}' +
    '@media (min-width:1000px){.btol-sticky-keuze{display:none}}';
  document.head.appendChild(st);

  function maatVeld() {
    var vp = document.querySelector('variant-picker[context="main_product"]') || document.querySelector('variant-picker');
    if (!vp) return null;
    var sets = vp.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /maat|afmeting|size|dimension|taille/i.test(lg.textContent) && sets[i].querySelector('input[type="radio"]')) return sets[i];
    }
    return null;
  }
  function kort(t) { return t.split('+')[0].replace(/\s*cm\s*$/i, '').trim(); }

  function bouw() {
    var bar = document.querySelector('product-sticky-bar');
    var veld = maatVeld();
    if (!bar || !veld) return;
    var radios = veld.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;
    var sel = bar.querySelector('.btol-sticky-keuze');
    if (!sel) {
      sel = document.createElement('select');
      sel.className = 'btol-sticky-keuze';
      sel.setAttribute('aria-label', btolT('kies_je_maat', 'Kies je maat'));
      sel.addEventListener('change', function () {
        var v = maatVeld();
        var r = v && v.querySelector('input[type="radio"][value="' + sel.value + '"]');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      var bb = bar.querySelector('buy-buttons');
      bar.insertBefore(sel, bb || null);
      bar.classList.add('btol-sticky--keuze');
    }
    var html = '', gekozen = '';
    radios.forEach(function (r) {
      var l = document.querySelector('label[for="' + r.id + '"]');
      var t = kort((l ? l.textContent : r.value).replace(/\s+/g, ' '));
      if (r.checked) gekozen = r.value;
      html += '<option value="' + r.value + '"' + (r.disabled ? ' disabled' : '') + '>' + t.replace(/</g, '') + '</option>';
    });
    if (sel.getAttribute('data-html') !== html) { sel.innerHTML = html; sel.setAttribute('data-html', html); }
    if (gekozen && sel.value !== gekozen) sel.value = gekozen;
  }
  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(bouw, 60); }
  function start() {
    if (!document.querySelector('product-sticky-bar')) return;
    bouw();
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) straks(); });
    /* het thema bouwt de vaste knop opnieuw op bij een andere maat: meteen (zonder wachten) de keuzelijst terugzetten, zodat er niets verspringt */
    if (window.MutationObserver) new MutationObserver(function () {
      var bar = document.querySelector('product-sticky-bar');
      if (bar && !bar.querySelector('.btol-sticky-keuze')) bouw(); else straks();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();